import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ApiOutlined } from '@ant-design/icons'
import TerminalOverview from './TerminalOverview'
import TerminalLedger from './TerminalLedger'
import TerminalAssets from './TerminalAssets'
import TerminalExceptions from './TerminalExceptions'
import './terminal.less'

const TABS = [
  { key: 'overview', label: '总览', path: '/portal/aic-dashboard/v2/overview' },
  { key: 'datasets', label: '数据源', path: '/portal/aic-dashboard/v2/datasets' },
  { key: 'assets', label: '运行资产', path: '/portal/aic-dashboard/v2/assets' },
  { key: 'exceptions', label: '异常中心', path: '/portal/aic-dashboard/v2/exceptions' },
  { key: 'settings', label: '设置', path: null, disabled: true }
]

const LEGACY_ENTRY_PATH = '/portal/aic-dashboard/datasets'
// P5：AIC 数据资产 tab 已改为看板入口，Skill 入口直接指向 Skill 市场，避免跳到循环入口页。
const AIC_SKILL_ENTRY_PATH = '/portal/profile?tab=skillmarket'

/** 路径 → 页面。V2 五个路由共用同一个壳组件，按 pathname 区分。 */
export const resolveTerminalPage = pathname => {
  const path = pathname || ''
  if (path.includes('/v2/assets')) return 'assets'
  if (path.includes('/v2/exceptions')) return 'exceptions'
  if (path.includes('/v2/datasets')) return 'datasets'
  return 'overview'
}

export default function AicTerminal () {
  const history = useHistory()
  const location = useLocation()
  const page = resolveTerminalPage(location.pathname)

  return <div className="term-shell">
    <div className="term-top">
      <div className="term-logo" aria-label="AIC 数据看板">AIC</div>
      <nav className="term-tabs" aria-label="AIC 看板 V2 导航">
        {TABS.map(tab => tab.disabled
          ? <button
            key={tab.key}
            type="button"
            className="term-tab term-tab-disabled"
            disabled
            title="暂未开放"
          >
            {tab.label}
            <span className="term-tab-note">暂未开放</span>
          </button>
          : <button
            key={tab.key}
            type="button"
            className={`term-tab ${page === tab.key ? 'on' : ''}`}
            aria-current={page === tab.key ? 'page' : undefined}
            onClick={() => history.push(tab.path)}
          >
            {tab.label}
          </button>)}
      </nav>
      <div className="term-top-actions">
        <span className="term-readonly">只读</span>
        <button
          type="button"
          className="term-ghost"
          onClick={() => history.push(LEGACY_ENTRY_PATH)}
        >
          旧版看板
        </button>
        <button
          type="button"
          className="term-primary"
          onClick={() => history.push(AIC_SKILL_ENTRY_PATH)}
        >
          <ApiOutlined className="term-icon" /><span>获取 AIC Skill</span>
        </button>
      </div>
    </div>
    <div className="term-body">
      {page === 'datasets' && <TerminalLedger />}
      {page === 'assets' && <TerminalAssets />}
      {page === 'exceptions' && <TerminalExceptions />}
      {page === 'overview' && <TerminalOverview />}
    </div>
  </div>
}
